import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FileDoc.es.js";
const e = o.forwardRef((c, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...c, weights: a }));
e.displayName = "FileDocIcon";
const s = e;
export {
  s as FileDoc,
  e as FileDocIcon
};
